import React from 'react';
import {
  BorderOutlined,
  DeleteOutlined,
  EditOutlined,
  FontSizeOutlined,
  FormOutlined,
  HighlightOutlined,
  RadiusSettingOutlined,
  SelectOutlined,
  ColumnHeightOutlined
} from '@ant-design/icons';

/** 侧栏工具列表（含图标，供工具条渲染） */
export const TOOLS = [
  { key: 'route', icon: <EditOutlined />, title: '画路线', tip: '点击加点；绘制中为橙色，右键/双击完成后变为所选颜色；可插点/拖顶点/Del 删除' },
  { key: 'measure', icon: <ColumnHeightOutlined />, title: '测距', tip: '点击多点测距；绘制中橙色，完成后变为所选颜色；可插点/拖顶点/Del 删除' },
  { key: 'polygon', icon: <RadiusSettingOutlined />, title: '绘制区域', tip: '点击围成多边形；绘制中橙色，完成后变为所选颜色；可「编辑形状」/Del 删除' },
  { key: 'rectangle', icon: <BorderOutlined />, title: '矩形选框', tip: '点击对角两点画矩形；绘制中橙色，完成后变为所选颜色；可编辑四角/Del 删除' },
  { key: 'sketch', icon: <FormOutlined />, title: '自由绘画', tip: '拖动画线（预览色）；抬笔后变为完成色；可选中改色/线宽/删除' },
  { key: 'text', icon: <FontSizeOutlined />, title: '文字', tip: '点击地图放置文字；可调字体/字号/字距/行距/颜色/背景；可拖动、再编辑、删除' },
  { key: 'select', icon: <SelectOutlined />, title: '选择', tip: '单击选中；拖动画框框选多个；可批量换色/删除；Shift+框选可追加；Del 删除' },
  { key: 'fill', icon: <HighlightOutlined />, title: '填充', tip: '对选中的区域开关填充' },
  { key: 'eraser', icon: <DeleteOutlined />, title: '橡皮擦', tip: '点击图形删除；可一键清空' }
];
